import { useState, useEffect, useCallback } from "react";

const usePdfViewer = () => {
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Function to directly load PDF from URL
  const loadPdfForInvoice = useCallback((invoiceId, directUrl = null) => {
    
    setSelectedInvoiceId(invoiceId);
    setIsLoading(true);
    setError(null);
    
    try {
      if (directUrl) {
 
        setPdfUrl(directUrl);
      } else {
 
        setError("No PDF URL available for this invoice");
        setPdfUrl(null);
      }
    } catch (err) {
      console.error('Error setting PDF URL:', err);
      setError('Failed to load the PDF document.');
      setPdfUrl(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Reset zoom when a new PDF is loaded
  useEffect(() => {
    if (pdfUrl) {
      setZoomLevel(1);
    }
  }, [pdfUrl]);

  // Zoom in
  const zoomIn = useCallback(() => {
    setZoomLevel(prev => Math.min(prev + 0.25, 3));
  }, []);

  // Zoom out
  const zoomOut = useCallback(() => {
    setZoomLevel(prev => Math.max(prev - 0.25, 0.5));
  }, []);

  // Reset zoom to 100%
  const resetZoom = useCallback(() => {
    setZoomLevel(1);
  }, []);

  // Toggle expanded view
  const toggleExpanded = useCallback(() => {
    setIsExpanded(prev => !prev);
  }, []);

  return {
    selectedInvoiceId,
    setSelectedInvoiceId,
    pdfUrl,
    setPdfUrl,
    isExpanded,
    zoomLevel,
    isLoading,
    error,
    setError,
    zoomIn,
    zoomOut,
    resetZoom,
    toggleExpanded,
    loadPdfForInvoice
  };
};

export default usePdfViewer;

